import { useEffect, useState } from "react";

export type Period = "dawn" | "day" | "dusk" | "night";

export function periodOf(h: number): Period {
  if (h >= 5 && h < 8) return "dawn";
  if (h >= 8 && h < 17) return "day";
  if (h >= 17 && h < 20) return "dusk";
  return "night";
}

/** The visitor's own hour, as Atzmai's sky follows it. */
export function usePeriod() {
  const [period, setPeriod] = useState<Period>(() => periodOf(new Date().getHours()));
  useEffect(() => {
    const t = setInterval(() => setPeriod(periodOf(new Date().getHours())), 60_000);
    return () => clearInterval(t);
  }, []);
  return period;
}

/** The sky behind the top of a page; `short` for a page that is not the home page. */
export function SkyBand({ period, short = false }: { period: Period; short?: boolean }) {
  return (
    <div className={`sky-band${short ? " sky-band-short" : ""}`} data-t={period} aria-hidden="true">
      <div className="sun" />
    </div>
  );
}
